import { __awaiter } from "tslib";
import a from '../base/config';
import Cookies from 'js-cookie';
import SERVICE_CONSTANTS from '@/constants/services';
import moment from 'moment';
import jwtDecode from 'jwt-decode';
import { getPassportUrl } from '@/utils/other';
const location = window.location;
export const host = location.hostname.split('.').reverse()[1] + '.' + location.hostname.split('.').reverse()[0];
const getFirstLevelPath = () => {
    let resultAddress = window.location.origin;
    if (window.location.pathname.split('/').length > 1) {
        resultAddress += '/' + window.location.pathname.split('/')[1];
    }
    return resultAddress;
};
export const redirectToLogin = () => {
    Cookies.set('jwtr', '', {
        expires: moment().subtract(1, 'days').toDate(),
        domain: '.' + host,
        sameSite: 'Strict'
    });
    window.location.href = getPassportUrl('/', { withAcceptor: true });
};
export function tryRefresh() {
    return __awaiter(this, void 0, void 0, function* () {
        const token = Cookies.get('jwtr');
        if (token) {
            const refreshResponse = yield a.post(SERVICE_CONSTANTS.PASSPORT_API + '/token/refresh/', {
                refresh: token
            }, { withCredentials: true });
            if (refreshResponse && refreshResponse.status === 200 && refreshResponse.data.refresh) {
                const refresh = refreshResponse.data.refresh;
                Cookies.set('jwtr', refresh, {
                    expires: moment.unix(jwtDecode(refresh).exp).toDate(),
                    domain: '.' + host,
                    sameSite: 'Strict'
                });
                return true;
            }
            else
                return false;
        }
        return false;
    });
}
